import { render, staticRenderFns } from "./XuatNhapTon.vue?vue&type=template&id=06f7c742&scoped=true&"
import script from "./XuatNhapTon.vue?vue&type=script&lang=js&"
export * from "./XuatNhapTon.vue?vue&type=script&lang=js&"
import style0 from "./XuatNhapTon.vue?vue&type=style&index=0&id=06f7c742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f7c742",
  null
  
)

export default component.exports